import styled from "styled-components";

export const LotsLegendLineDescriptionStyled = styled.div`
    display: flex;
    align-items: center;
    color: var(--text-color-secondary);
    font-size: 10px;
`;

export const LotsLegendLineValueStyled = styled.div`
    color: var(--color-white);
    font-weight: 600;
    font-size: 12px;
`;

export const LotsLegendProgressBarStyled = styled.div`
    width: 100%;
    height: 4px;
    border-radius: 2px;
    background-color: var(--color-base);
    overflow: hidden;
`;

export const LotsLegendProgressBarSliderStyled = styled.div`
    background-color: var(--color-yellow);
    width: ${({ width }) => `${width || 0}%`};
    height: 100%;
`;
